import { type TopNavProps } from './TopNav.props'

export const defaultTopNavProps = {
  logo: {
    href: '/',
    altText: 'Bodi logo',
    src: 'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fbe73d1e15bab4510b776037797f287d3',
    desktopWidth: 99,
    desktopHeight: 32,
    mobileWidth: 76,
    mobileHeight: 24,
  },
  links: {
    signUp: {
      title: 'Sign up',
      href: 'https://www.beachbodyondemand.com/register-free',
    },
    logIn: {
      title: 'Log in',
      href: 'https://www.beachbodyondemand.com/hosted-login-page?locale=en_US',
    },
  },
  menus: [
    {
      hasDropdown: false,
      title: 'Home',
      href: '/',
      newTab: true,
    },
    {
      featuredItemMobile: {
        title: 'Try All for Free',
        href: '/offers',
      },
      featuredItemDesktop: {
        title: 'View All Programs',
        href: '/c/fitness',
      },
      hasFeaturedItemMobile: true,
      hasFeaturedItemDesktop: true,
      hasDropdown: true,
      title: 'Programs',
      items: [
        {
          title: 'P90X',
          href: '/s/fitness/p90x',
        },
        {
          title: '2B Mindset',
          href: 'https://www.teambeachbody.com/shop/us/d/2b-mindset-digital-streaming-2BStreamingAccess',
        },
        {
          title: '21 Day Fix',
          href: '/s/fitness/21-day-fix',
        },
        {
          title: 'Body Beast',
          href: '/s/fitness/p90x',
        },
        {
          title: '80 Day Obsession',
          href: '/s/fitness/80-day-obsession',
        },
        {
          title: 'Insanity',
          href: '/s/fitness/insanity',
        },
        {
          title: 'For Beginners Only',
          href: '/s/fitness/for-beginners-only',
        },
        {
          title: 'Tropical Strawberry Shakeology But in French!',
          href: 'https://www.teambeachbody.com/shop/us/d/portion-fix-digital-streaming-FIXStreamingAccess',
        },
      ],
    },
    {
      hasDropdown: true,
      title: 'Supplements',
      items: [
        {
          title: 'Shakeology',
          href: 'https://www.teambeachbody.com/shop/us/shakeology?locale=en_US',
        },
        {
          title: 'Energize',
          href: 'https://www.teambeachbody.com/shop/us/d/energize-BBPEnergizeAllFlavors?locale=en_US',
        },
        {
          title: 'Recover',
          href: 'https://www.teambeachbody.com/shop/us/d/recover-BBPRecoverAllFlavors?locale=en_US',
        },
        {
          title: 'Collagen',
          href: 'https://www.teambeachbody.com/shop/us/b/nutrition-supplement/collagenboost?locale=en_US',
        },
      ],
    },
  ],
  mobileFooterLinks: [
    {
      title: 'Account',
      href: 'https://www.teambeachbody.com/shop/us/account/settings?locale=en_US',
      newTab: true,
    },
    {
      title: 'Orders',
      href: 'https://www.teambeachbody.com/shop/us/account/settings?locale=en_US&tab=MyOrders',
      newTab: true,
    },
    {
      title: 'Memberships & Subscriptions',
      href: 'https://www.teambeachbody.com/shop/us/account/settings?locale=en_US&tab=membershipsandsubscriptions',
      newTab: true,
    },
    {
      title: 'Contact Us / FAQ',
      href: 'https://faq.beachbody.com/app/home?locale=en_US',
      newTab: true,
    },
  ],
} satisfies TopNavProps
